module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-pl.json
// module id = 157
// module chunks = 60335399758886 227926702607133